import { AlertSourcesView } from './AlertSourcesView'
export const DevicesPage = () => <AlertSourcesView />
